export const APP_ROLES = [
  'super_admin',
  'content_admin',
  'reviewer',
  'teacher',
  'parent',
  'student',
] as const;

export type AppRole = (typeof APP_ROLES)[number];

export interface AppUser {
  id: string;
  email: string;
  displayName: string;
  role: AppRole;
  demo?: boolean;
}

export interface NavItem {
  label: string;
  path: string;
  icon: string;
}

export const roleLabels: Record<AppRole, string> = {
  super_admin: 'Super Admin',
  content_admin: 'Content Admin',
  reviewer: 'Reviewer',
  teacher: 'Teacher',
  parent: 'Parent',
  student: 'Student',
};
